var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"all":"inherit","display":"flex"}},[_c('PollQuestionImage',{class:{
      'default-canvas-image-width': _vm.questionImageLayoutMode === _vm.layoutMode.default,
      'full-canvas-image-width' : _vm.questionImageLayoutMode === _vm.layoutMode.image,
      'hide-canvas-image': _vm.questionImageLayoutMode === _vm.layoutMode.chart,
      'invisible': !_vm.isInvisiblePollQuestionImage,
    },attrs:{"questionImageLayoutMode":_vm.questionImageLayoutMode},on:{"expandCollapseTrigger":_vm.updateQuestionImageLayoutMode}}),_c(_vm.chartName,{tag:"component",class:{
      'default-chart-width': _vm.questionImageLayoutMode === _vm.layoutMode.default && _vm.questionImage,
      'full-chart-width' : _vm.questionImageLayoutMode === _vm.layoutMode.chart,
      'hide-chart': _vm.questionImageLayoutMode === _vm.layoutMode.image,
    },attrs:{"hasImage":_vm.questionImage,"questionImageLayoutMode":_vm.questionImageLayoutMode},on:{"expandCollapseTrigger":_vm.updateQuestionImageLayoutMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }